<template>
  <b-form-input
    autofocus
    v-bind="$attrs"
    @change="handleChange"
    v-on:keyup.enter="handleChange"
    v-model="textSearch"
    :placeholder="placeHolder"
    class="flex-grow-1 w-100 mr-3"
    debounce="1000"
  ></b-form-input>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: null,
    },
    placeHolder: {
      type: String,
      default: 'Digite um termo e pressione enter para buscar',
    },
  },
  data() {
    return {
      textSearch: this.value,
    };
  },
  methods: {
    handleChange() {
      this.$emit('input', this.textSearch);
    },
  },
};
</script>
